import { RouterModule, Routes } from '@angular/router';
import { NgModule } from '@angular/core';
import { MainComponent } from  './main.component'
import { HomeComponent } from  './sys/home/home.component'

const routes: Routes = [{
  path: '',  
  component: MainComponent,
  children: [   
  
    {
      path: 'Home',
      component: HomeComponent,
    },
    {
      path: '',
      redirectTo: 'Home',
      pathMatch: 'full',
    },
    // {
    //   path: '**',
    //   redirectTo: '/Product/Setting',
    // },   
    {
      path: 'Store',
      loadChildren: () => import('./storemanage/storemanage.module')
        .then(m => m.StoreManageModule),
    },
    {
      path: 'Auth', loadChildren: () => import( './auth-manage/auth-manage.module')
        .then(m => m.AuthManageModule),
    },
    
    {
      path: 'Product',
      loadChildren: () => import( './product/product.module')
        .then(m => m.ProductModule),
    },      
    {
      path: 'Report', loadChildren: () => import( './report/report.module')
        .then(m => m.ReportModule),
    },
    {
      path: 'OperateReportManage',
      loadChildren: () => import('./OperateReportManage/operate-report-manage.module')
        .then(m => m.OperateReportManageModule),
    },
    {
      path: 'PosOrder', loadChildren: () => import( './pos-order/pos-order.module')
        .then(m => m.PosOrderModule),
    },

    //--------------------------------------------

    {
      path: 'order', loadChildren: () => import('./order/order.module')
        .then(m => m.OrderModule),
    },
    {
      path: 'EOS', loadChildren: () => import('./EOS/EOS.module')
        .then(m => m.EOSModule),
    },


    // {
    //   path: 'basic-info',
    //   loadChildren: () => import('./basic-info/basic-info.module')
    //     .then(m => m.BasicInfoModule),
    // }, 
    // {
    //   path: 'permissiongroup',
    //   loadChildren: () => import('./permissiongroup/permissiongroup.module')
    //     .then(m => m.PermissionGroupModule),
    // },
      
    // {
    //   path: 'pospermissions',
    //   loadChildren: () => import('./pospermissions/pospermissions.module')
    //     .then(m => m.POSPermissionsModule),
    // },

    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class MainRoutingModule { }
